import { render } from "./B2bFilterButtonOrdersEmit.vue?vue&type=template&id=3f87f32c&scoped=true&lang=pug"
import script from "./B2bFilterButtonOrdersEmit.vue?vue&type=script&lang=js"
export * from "./B2bFilterButtonOrdersEmit.vue?vue&type=script&lang=js"

import "./B2bFilterButtonOrdersEmit.vue?vue&type=style&index=0&id=3f87f32c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f87f32c"]])

export default __exports__